import { action, makeObservable, observable } from 'mobx';
const storage = localStorage;

export class Facility {
  @observable hotelList = ((storage.getItem('hotelList') &&
    JSON.parse(storage.getItem('hotelList') as string)) ||
    []) as { code?: string; name?: string }[];
  @observable hotelCode = storage.getItem('hotelCode') || '';
  @observable ticketsSlug = storage.getItem('ticketsSlug') || '';
  @observable ticketsDocumentId = storage.getItem('ticketsDocumentId') || '';
  @observable showAreaGuideNav = false;
  @observable showModelCoursesNav = false;
  @observable showTravelGuideNav = false;
  @observable showTicketsNav = false;

  constructor() {
    makeObservable(this);
  }

  @action
  setHotelList = (list: { code?: string; name?: string }[]) => {
    storage.setItem('hotelList', JSON.stringify(list));
  };

  @action
  getHotelList = () => {
    return this.hotelList;
  };

  @action
  setCode = (code: string) => {
    this.hotelCode = code;
  };

  @action
  getCode = () => {
    return this.hotelCode;
  };

  @action
  setTicketsSlug = (slug: string) => {
    this.ticketsSlug = slug;
    storage.setItem('ticketsSlug', slug);
  };

  @action
  getTicketsSlug = () => {
    return this.ticketsSlug;
  };

  @action
  setTicketsDocumentId = (documentId: string) => {
    this.ticketsDocumentId = documentId;
    storage.setItem('ticketsDocumentId', documentId);
  };

  @action
  getTicketsDocumentId = () => {
    return this.ticketsDocumentId;
  };

  @action
  setHomeNavVisibility = (payload: {
    areaGuide: boolean;
    modelCourses: boolean;
    travelGuide: boolean;
    tickets: boolean;
  }) => {
    this.showAreaGuideNav = payload.areaGuide;
    this.showModelCoursesNav = payload.modelCourses;
    this.showTravelGuideNav = payload.travelGuide;
    this.showTicketsNav = payload.tickets;
  };
}

export default new Facility();
